const firebaseConfig = {
  apiKey: "AIzaSyBgLiYUnliMsf6GcT11jfD-rnWvlNGs6Hc",
  authDomain: "flying-rover.firebaseapp.com",
  projectId: "flying-rover",
  storageBucket: "flying-rover.appspot.com",
  messagingSenderId: "765648033688",
  appId: "1:765648033688:web:b46accb6091c5f50bd3ded"
  };

export default firebaseConfig;